/* eslint-disable react/prop-types */
import Authenticate from './components/AuthUI';
import { BrowserRouter as Router, Route, Navigate, Routes, useLocation } from 'react-router-dom';
import DebugPage from './debugPage'

function App() {

  const RouteElement = ({ location, from, children }) => {
    const { pathname } = location
    const LoggedinFlag = window.localStorage.getItem('spaceio-key')

    return pathname === '/login'
      ?
      (
        LoggedinFlag
          ?
          <Navigate to={from} />
          : (children)
      )
      :
      (
        LoggedinFlag
          ?
          children
          :
          <Navigate to={'/login'} state={{ from: location }} />
      )
  }

  const ProtectedRoute = ({ children }) => {
    const location = useLocation()
    const { from } = location.state || { from: { pathname: '/deviceDebug' } }
    return <RouteElement location={location} from={from} caseSensitive>{children}</RouteElement>
  }

  return (
    <>
      <Router>
        <Routes>
          <Route index element={<Authenticate />}></Route>
          <Route path='login' element={<ProtectedRoute><Authenticate /></ProtectedRoute>}></Route>
          <Route path='deviceDebug' element={<ProtectedRoute><DebugPage /></ProtectedRoute>}></Route>
        </Routes>
      </Router>
    </>
  )
}

export default App


